/**
 * @generated SignedSource<<c9ce339423fef9025967c3ab96c83b59>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_user">;
  readonly " $fragmentType": "PdpRespSimilarItemsGrid_user";
};
export type PdpRespSimilarItemsGrid_user$key = {
  readonly " $data"?: PdpRespSimilarItemsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGrid_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "660a1166d6803ad948b93a44a4079443";

export default node;
